import { createAction } from '@reduxjs/toolkit';
import { IItemRequest } from '../../shared';
import {
  ExplorePanelActionTypes, ExplorePerformanceDataSelectorsResponse, PerformanceDataSelections,

} from './models';


// Use createAction helper functions since they are stictly typed out of the box

export const loadPDSelectorsStart = createAction(
  ExplorePanelActionTypes.LOAD_SELECTORS_START,
  (payload: IItemRequest) => ({ payload })
);

export const loadPDSelectorsSuccess = createAction(
  ExplorePanelActionTypes.LOAD_SELECTORS_SUCCESS,
  (payload: ExplorePerformanceDataSelectorsResponse) => ({ payload })
);

export const loadPDSelectorsFailure = createAction(
  ExplorePanelActionTypes.LOAD_SELECTORS_FAILURE,
  // TODO: Add and implement ErrMsg Interface
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (errMsg: any) => ({
    payload: errMsg,
  })
);

export const changePDSelections = createAction(
  ExplorePanelActionTypes.CHANGE_SELECTIONS,
  (payload: PerformanceDataSelections) => ({payload})
);
